import { render, staticRenderFns } from "./VideoRecord.vue?vue&type=template&id=5259f093&scoped=true&"
import script from "./VideoRecord.vue?vue&type=script&lang=js&"
export * from "./VideoRecord.vue?vue&type=script&lang=js&"
import style0 from "./VideoRecord.vue?vue&type=style&index=0&id=5259f093&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5259f093",
  null
  
)

export default component.exports